package com.zq.webproject.ui.invite

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import com.zq.webproject.model.InvitedUser
import com.zq.webproject.network.Repository
import com.zq.webproject.utils.TokenManager
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch

/**
 * 邀请用户列表ViewModel
 */
class InvitedUsersViewModel {
    private val repository = Repository()
    private val scope = CoroutineScope(Dispatchers.Default)

    // 邀请的用户列表
    var invitedUsers by mutableStateOf<List<InvitedUser>>(emptyList())
        private set

    // 加载状态
    var isLoading by mutableStateOf(false)
        private set

    // 错误消息
    var errorMessage by mutableStateOf<String?>(null)
        private set

    /**
     * 加载邀请用户列表
     */
    fun loadInvitedUsers() {
        scope.launch {
            val token = TokenManager.getToken()
            if (token.isNullOrEmpty()) {
                println("InvitedUsersViewModel - Token为空，无法加载邀请用户列表")
                errorMessage = "未登录，无法获取邀请用户列表"
                return@launch
            }

            println("InvitedUsersViewModel - 开始加载邀请用户列表")
            isLoading = true
            errorMessage = null

            val result = repository.getInvitedUsers(token)

            if (result.isFailure) {
                val error = "获取邀请用户列表失败: ${result.exceptionOrNull()?.message}"
                println("InvitedUsersViewModel - $error")
                errorMessage = error
                isLoading = false
                return@launch
            }

            val response = result.getOrNull()
            if (response?.code == 200 && response.data != null) {
                invitedUsers = response.data
                println("InvitedUsersViewModel - 邀请用户列表加载成功，共 ${response.data.size} 个用户")

                // 打印前3个用户用于调试
                response.data.take(3).forEachIndexed { index, user ->
                    println("InvitedUsersViewModel - 用户${index + 1}: ID=${user.id}, 手机=${user.phone}, 余额=${user.balance}, 角色=${user.role}")
                }
            } else {
                val errorMsg = response?.message ?: "数据为空"
                errorMessage = "获取邀请用户列表失败: $errorMsg"
                println("InvitedUsersViewModel - $errorMessage")
            }

            isLoading = false
        }
    }
}